export default {
  catalogue: "项目目录".toUpperCase(),
  blog: "博客".toUpperCase(),
  faq: "常见问题".toUpperCase(),
  about_fraudvision: "关于 FraudVision".toUpperCase(),
  contact_us: "联系方式".toUpperCase(),

  thats_the_vision: "thats the vision".toUpperCase(),
};
